'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(t);
        for(o = 0; o < s.length; o++)r = s[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, n = {}, s = Object.keys(t);
    for(o = 0; o < s.length; o++)r = s[o], e.indexOf(r) >= 0 || (n[r] = t[r]);
    return n;
}
const Count = renderWithRef('Count', null, (r, o)=>{
    var { children: n, skin: s = 'standard' } = r, i = _object_without_properties(r, [
        "children",
        "skin"
    ]);
    let c = new Set([
        'swan-count'
    ]);
    return 'standard' != s && c.add(`swan-count-skin-${s}`), jsx(RenderComp, {
        root: "span",
        classNames: c,
        forwardedRef: o,
        props: i,
        children: n
    });
});

export { Count };
